export default "__VITE_ASSET__C6tazWP2__"